import { useState, useEffect } from "react"

import * as CONF from "../config"

// import { imageURL } from "../data/images2"
// import { imageURL } from "../content/sample_utils.js"

import { randomFromString, roundRand, limitRand } from "../utils/randomness"

import "./Composition.sass"

function generateSeed(words = [], index) {
	if (index === 0) {
		return words[0][0]
	} else {
		const seedWords = words.slice(0, index)
		return seedWords.join(" ")
	}
}

export default function Composition({
	images = [],
	seed = "",
	className,
	children,
}) {
	const [elements, setElements] = useState([])

	useEffect(() => {
		// const rand = randomFromString(seed)
		// const layerCount = roundRand(rand, MIN_LAYERS, CONF.MAX_LAYERS)

		const stack = []
		const words = seed.split(" ")

		for (let i = 0; i < words.length && words[i] !== ""; i++) {
			const trimmedSeed = generateSeed(words, i)
			const isOverMaxLayers = words.length > CONF.MAX_LAYERS
			const isCulledLayer = i < words.length - CONF.MAX_LAYERS
			const skipCulledLayer = isOverMaxLayers && isCulledLayer
			if (skipCulledLayer) {
				// skip
			} else {
				const key = `el-${i}-${words[i]}`

				const rand2 = randomFromString(trimmedSeed)

				const imgIndex = roundRand(rand2, 0, images.length - 1)
				const img = images[imgIndex]

				if (!img) break

				// const maxScale = img.islarge ? CONF.MAX_SCALE / 1.125 : CONF.MAX_SCALE

				const scale = img.grounded
					? limitRand(rand2, CONF.MAX_SCALE, CONF.MAX_SCALE * 1.25)
					: img.huge
					? limitRand(
							rand2,
							CONF.MIN_SCALE + (CONF.MAX_SCALE - CONF.MIN_SCALE) / 2,
							CONF.MAX_SCALE,
					  )
					: img.tiny
					? limitRand(
							rand2,
							CONF.MIN_SCALE,
							CONF.MAX_SCALE - (CONF.MAX_SCALE - CONF.MIN_SCALE) / 1.25,
					  )
					: img.airborne
					? limitRand(rand2, CONF.MIN_SCALE / 2, CONF.MAX_SCALE / 2)
					: limitRand(rand2, CONF.MIN_SCALE, CONF.MAX_SCALE)

				const width = limitRand(rand2, CONF.MIN_WIDTH, CONF.MAX_WIDTH)
				const height = limitRand(rand2, CONF.MIN_HEIGHT, CONF.MAX_HEIGHT)
				const scaleX = scale * (!!img.noflip ? 1 : rand2() > 0.5 ? 1 : -1)
				const scaleY = scale
				// const hue = limitRand(rand2, CONF.MIN_HUE, CONF.MAX_HUE)
				const rotation = img.rotatable
					? limitRand(rand2, CONF.MIN_ROTATION, CONF.MAX_ROTATION)
					: 0
				const src = "/" + img.file
				const x = limitRand(rand2, CONF.MIN_X, CONF.MAX_X)

				const DELTA = CONF.MAX_Y - CONF.MIN_Y
				const RANGE = DELTA / 4
				const MID = DELTA / 2 + CONF.MIN_Y

				const y = img.grounded
					? limitRand(rand2, CONF.MIN_Y + RANGE / 2, MID - RANGE / 2)
					: img.airborne
					? limitRand(rand2, CONF.MAX_Y - RANGE / 2, CONF.MAX_Y * 1.75)
					: limitRand(rand2, MID - RANGE / 2, MID + RANGE / 2)

				const translate = img.grounded ? "-50%, -100%" : "-50%, -50%"

				const transformOrigin = img.grounded ? "bottom center" : "center center"

				const z = limitRand(
					rand2,
					// CONF.MIN_Z,
					// CONF.MAX_Z,
					img.grounded ? CONF.MIN_Z : CONF.MIN_Z,
					img.grounded ? CONF.MIN_Z : CONF.MAX_Z,
				)

				stack.push({
					word: words[i],
					key,
					x,
					y,
					z,
					width,
					height,
					scaleX,
					scaleY,
					// hue,
					rotation,
					src,
					transformOrigin,
					translate,
					i: words.length - i,
					o: i,
					imgIndex,
				})
			}
		}

		setElements(stack)
	}, [seed, images])

	if (typeof children !== "function") return false

	return children(elements)
}
